const config = {
  siteTitle: 'Blog by tegarsantosa',
  siteUrl: 'https://blog.tegarsantosa.com',
  siteLogo: '/logo.png',
  description:
    'Software engineer and open source creator. This is my digital garden.',
}

export default config
